'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: hidden;\n  max-height: 300px;\n'], ['\n  position: relative;\n  overflow: hidden;\n  max-height: 300px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 1rem;\n  width: 100%;\n  height: 50%;\n  background: linear-gradient(0deg, white, rgba(255,255,255,0));\n'], ['\n  position: absolute;\n  bottom: 1rem;\n  width: 100%;\n  height: 50%;\n  background: linear-gradient(0deg, white, rgba(255,255,255,0));\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: inline-block;\n  border: 1px solid rgba(0,0,0,0.75);\n  background-color: #fff;\n  color: rgba(0,0,0,0.75);\n  text-decoration: none;\n  padding: .25rem .5rem;\n  text-decoration: none;\n  &:hover {\n    color: #fff;\n    background-color: #333;\n  }\n'], ['\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: inline-block;\n  border: 1px solid rgba(0,0,0,0.75);\n  background-color: #fff;\n  color: rgba(0,0,0,0.75);\n  text-decoration: none;\n  padding: .25rem .5rem;\n  text-decoration: none;\n  &:hover {\n    color: #fff;\n    background-color: #333;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Article = _styledComponents2.default.div(_templateObject);

var ArticleShade = _styledComponents2.default.div(_templateObject2);

var ReadMoreButton = _styledComponents2.default.button(_templateObject3);

/** @class ArticleContent
  * A component for displaying HTML content
  */

var ArticleContent = function (_Component) {
  _inherits(ArticleContent, _Component);

  /** @constructor
    * Constructs a new instance.
    * @prop {string} html - the HTML to display
    */
  function ArticleContent(props) {
    _classCallCheck(this, ArticleContent);

    var _this = _possibleConstructorReturn(this, (ArticleContent.__proto__ || Object.getPrototypeOf(ArticleContent)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /** @method handleClick
    * Displays the full HTML content in an overlay
    */


  _createClass(ArticleContent, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      if (window.vexpo && window.vexpo.overlay) window.vexpo.overlay(this.props);
    }
    /** @method
     * Renders the Article Content component.
     */

  }, {
    key: 'render',
    value: function render() {
      var body = { __html: this.props.html };
      return _react2.default.createElement(
        Article,
        { onClick: this.handleClick },
        _react2.default.createElement('div', { dangerouslySetInnerHTML: body }),
        _react2.default.createElement(ArticleShade, null),
        _react2.default.createElement(
          ReadMoreButton,
          { href: '#', onClick: this.handleClick },
          'Read More...'
        )
      );
    }
  }]);

  return ArticleContent;
}(_react.Component);

exports.default = ArticleContent;


ArticleContent.propTypes = {
  html: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/content/article-content.js
// module id = 650
// module chunks = 0